import { Box } from '@mui/material';

import { DotIndicator } from '../DotIndicator';
import { DotIndicatorProps } from '../DotIndicator/DotIndicator';

export type PrequalificationStatus = 'green' | 'yellow' | 'red' | 'grey';

const STATUS_COLOR_MAP: Record<PrequalificationStatus, DotIndicatorProps['color']> = {
  green: 'success',
  yellow: 'warning',
  red: 'error',
  grey: 'grey',
};

export const PrequalificationIndicator = ({ status }: { status: PrequalificationStatus }) => {
  return (
    <Box component="span" sx={{ display: 'inline-flex', ml: 0.5, verticalAlign: 'middle' }}>
      <DotIndicator color={STATUS_COLOR_MAP[status] ?? 'grey'} />
    </Box>
  );
};
